import { Component, Input } from '@angular/core';
import { DataLayerType } from '../../../models/data-layer-type';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-data-layer-type-icon',
  standalone: true,
  imports: [SvgIconComponent, NgIf],
  templateUrl: './data-layer-type-icon.component.html',
  styleUrl: './data-layer-type-icon.component.scss',
})
export class DataLayerTypeIconComponent {
  @Input() dataLayerType!: DataLayerType;
}
